// src/lib/telemetry/db.ts
import { addDoc, collection, getFirestore, serverTimestamp } from 'firebase/firestore';
import type { Report } from './types';

export async function addReport(data: Omit<Report, 'createdAt' | 'updatedAt'>) {
  const db = getFirestore();
  const ref = await addDoc(collection(db, 'reports'), {
    ...data,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref.id;
}
